<div class="mindmap-container d-flex justify-content-center align-items-center">
	<svg [attr.width]="width" [attr.height]="height" class="w-100 h-100">
		<!-- Draw connections -->
		<ng-container *ngFor="let node of nodes">
			<line *ngIf="node.parentId !== undefined" [attr.x1]="getParentNode(node)?.x"
				[attr.y1]="getParentNode(node)?.y" [attr.x2]="node.x" [attr.y2]="node.y" stroke="#f9bd63"
				stroke-width="2">
			</line>
		</ng-container>

		<!-- Draw nodes -->
		<g *ngFor="let node of nodes" (mouseenter)="onNodeHover(node)" (mouseleave)="onNodeLeave()">
			<ng-container [ngSwitch]="node.shape">
				<!-- Draw squares -->
				<rect *ngSwitchCase="'square'" [attr.x]="node.x - 20" [attr.y]="node.y - 20" width="130" height="40"
					class="fill-pink rounded">
				</rect>
				<!-- Draw rounded corner squares instead of ovals -->
				<rect *ngSwitchCase="'oval'" [attr.x]="node.x - 10" [attr.y]="node.y - 15" width="120" height="30"
					class="rounded-square" rx="10" ry="10">
				</rect>

				<!-- Draw circles -->
				<circle *ngSwitchCase="'circle'" [attr.cx]="node.x" [attr.cy]="node.y" r="20" class="fill-orange">
				</circle>
			</ng-container>

			<!-- Labels for nodes -->
			<text [attr.x]="node.x" [attr.y]="node.y" class="text-white text-center" dy=".3em"
				*ngIf="node.shape!='square'">
				{{ node.label }}
			</text>
			<text [attr.x]="node.x" [attr.y]="node.y" class="text-white text-center" dy=".3em"
				*ngIf="node.shape=='square'">
				{{ node.label }} : {{ node.value }}
			</text>
		</g>

		<!-- Tooltip for node hover -->
		<foreignObject *ngIf="hoveredNode" [attr.x]="hoveredNode.x -10 " [attr.y]="hoveredNode.y - 40" width="150"
			height="50">
			<div class="d-flex align-items-center justify-content-center rounded ">
				<div class="tooltip-container bg-light text-dark p-2 " *ngIf="hoveredNode.percentage">
					<span>{{ hoveredNode.label }}</span>
					<div>
						count: {{ hoveredNode.value }} | {{hoveredNode.percentage}}%
					</div>
				</div>
			</div>
		</foreignObject>
	</svg>
</div>